/** 与 backend/models/Instrument.js 中 reservationRules 默认值一致 */
export const DEFAULT_INSTRUMENT_MIN_DURATION_MINUTES = 30;
export const DEFAULT_INSTRUMENT_MAX_DURATION_MINUTES = 240;

type RulesShape = { minDuration?: number; maxDuration?: number } | null | undefined;

/**
 * 解析单次预约时长上下限（列表接口不返回 rules 时仍用模型默认，避免前端放行超长预约）
 */
export function getEffectiveReservationDurationLimits(instrument?: {
  reservationRules?: RulesShape;
} | null): { minDuration: number; maxDuration: number } {
  const r = instrument?.reservationRules;
  const rawMin = r?.minDuration;
  const rawMax = r?.maxDuration;
  const minDuration =
    typeof rawMin === 'number' && Number.isFinite(rawMin) && rawMin > 0
      ? rawMin
      : DEFAULT_INSTRUMENT_MIN_DURATION_MINUTES;
  const maxDuration =
    typeof rawMax === 'number' && Number.isFinite(rawMax) && rawMax > 0
      ? rawMax
      : DEFAULT_INSTRUMENT_MAX_DURATION_MINUTES;
  const lo = Math.min(minDuration, maxDuration);
  const hi = Math.max(minDuration, maxDuration);
  return { minDuration: lo, maxDuration: hi };
}
